import React, { useState } from 'react'; // Import useState hook
import './jobmenu.css'; // Importing the CSS for styling
import { logDiagnostic } from '../../utils/diagnosticLogger';

const JobMenu = ({ setActiveComponent }) => {
  // State to track the currently active component
  const [activeComponent, setActive] = useState('workOrderList');

  // Function to handle menu item click
  const handleMenuItemClick = (componentName) => {
    logDiagnostic('navigation', 'jobmenu-click', {
      from: activeComponent,
      to: componentName,
      timestamp: Date.now()
    });
    setActiveComponent(componentName); // Update the parent component's active component
    setActive(componentName); // Update the local active component state
  };

  return (
    <div className='menu'>
      <div className={`menu-item ${activeComponent === 'workOrderList' ? 'active' : ''}`} onClick={() => handleMenuItemClick('workOrderList')}>Job Orders</div>
      <div className={`menu-item ${activeComponent === 'archived' ? 'active' : ''}`} onClick={() => handleMenuItemClick('archived')}>Archived</div>
      
    </div>
  );
};

export default JobMenu; 